import { defineMessages } from "react-intl";

export default defineMessages({
    emptyFolder: {
        id: "components.thumbnail.thumbnailWrapper.emptyFolder",
        defaultMessage: "This folder is empty", // Dieser Ordner ist leer
    },
});
